import React, { useState, useEffect } from "react";
import { Button } from "Components/Button";
import KeyboardHint from "Components/KeyboardHint";
import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import { marketingCapabilitiesData } from "Data";
import formStyles from "Styles/CompanySize.module.css";
import inputStyles from "Styles/Inputs.module.css";
import styles from "Styles/components/CheckboxCard.module.css";

const MarketingCapabilitiesFormContent = ({
  submitCB = () => {},
  defaultCapabilities = [],
}) => {
  const [checkedValues, setCheckedValues] = useState(defaultCapabilities);

  useEffect(() => {
    if (defaultCapabilities && defaultCapabilities.length > 0) {
      setCheckedValues(defaultCapabilities);
    }
  }, [defaultCapabilities]);

  const handleToggle = (value) => {
    if (checkedValues.includes(value)) {
      setCheckedValues((prev) => prev.filter((item) => item !== value));
    } else {
      setCheckedValues((prev) => [...prev, value]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitCB(checkedValues);
  };

  const parseLabel = (label) => {
    if (label.includes("\n")) {
      const [title, ...descParts] = label.split("\n");
      return { title, description: descParts.join("\n") };
    }
    return { title: label, description: "" };
  };

  return (
    <InfoContentMotionWrapper>
      <div className={formStyles.content}>
        <fieldset className={inputStyles.fieldset}>
          <legend className={inputStyles.legend}>至少選擇一個</legend>
          <form className={inputStyles.form} onSubmit={handleSubmit}>
            <div className={styles.cardGrid}>
              {marketingCapabilitiesData.map((item) => {
                const isChecked = checkedValues.includes(item.value);
                const { title, description } = parseLabel(item.label);

                return (
                  <label
                    key={item.value}
                    className={`${styles.cardItem} ${isChecked ? styles.checked : ""}`}
                  >
                    <input
                      type="checkbox"
                      className={styles.cardInput}
                      value={item.value}
                      checked={isChecked}
                      onChange={() => handleToggle(item.value)}
                    />
                    <span className={styles.cardTitle}>{title}</span>
                    {description && (
                      <span className={styles.cardDescription}>
                        {description}
                      </span>
                    )}
                  </label>
                );
              })}
            </div>

            <div style={{ display: "flex", alignItems: "end", gap: "0.75rem" }}>
              <Button
                disabled={checkedValues.length < 1}
                marginTop
                type="action"
                submit
              >
                OK
              </Button>
              <KeyboardHint />
            </div>
          </form>
        </fieldset>
      </div>
    </InfoContentMotionWrapper>
  );
};

export default MarketingCapabilitiesFormContent;
